<template>
  <ul class="vx-timeline">
    <li v-for="item in data" :key="item.title">
      <div class="timeline-icon" :class="`bg-${item.color}`">
        <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
      </div>
      <div class="timeline-info">
        <p class="font-semibold">{{ item.title }}</p>
      </div>
      <div v-if="item.type === 'invoice'">
        <span class="activity-desc" v-if="item.desc">
          <div v-for="d in item.desc">
            <span v-if="d.invoice">
              {{ d.devis }} → {{ d.invoice }} <b style="color:green">V</b>
            </span>
            <span v-else>
              <a :href="d.link" class="items-center text-blue-500">
                {{ d.devis }} → <b style="color:red">X</b>
              </a>
            </span>
          </div>
        </span>
      </div>
      <div v-else-if="item.type === 'uit'">
        <span class="activity-desc" v-if="item.desc">
          <div v-for="d in item.desc">
            <span v-if="d.uit && d.invoice">
              {{ d.invoice }} → {{ d.uit }} <b style="color:green">V</b>
            </span>
            <span v-else-if="d.internal && d.invoice" class="text-grey">
              {{ d.invoice }} → internal transport (no UIT)
            </span>
            <span v-else-if="d.invoice">
              <a :href="d.linketransport" class="items-center text-blue-500">
                {{ d.invoice }} → <b style="color:red">X</b>
              </a>
            </span>
            <span v-else>
              <b style="color:red"><br /></b>
            </span>
          </div>
        </span>
      </div>
      <div v-else-if="item.type === 'document'">
        <span class="activity-desc">
          <div v-for="d in item.desc">
            <span v-if="d.invoice">
              Invoice
              {{ d.invoice }} →
              <!--
                Le PDF est genere par l'ecran appelant, comme le CMR juste en
                dessous. L'ancien lien ouvrait la page publique destinee au
                client (compte a rebours de 4 s) dans un nouvel onglet.
              -->
              <b style="color:green; cursor: pointer;" @click="item.buttonInvoice(d.idinvoice)">Download</b>
            </span>
          </div>
          <span v-if="item.color == 'success'">
            CMR → <b style="color:green; cursor: pointer;" @click="item.buttonCmr()">Download</b>
          </span><br/>
          <span v-if="item.color == 'success'">
            AVIZ (RECEPTION / CLIENT LANGUAGE + ROMANIAN)→ <b style="color:green; cursor: pointer;" @click="item.buttonReception()">Download</b>
          </span>
        </span>
      </div>
      <small class="text-grey activity-e-time">{{ item.time }}</small>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'vx-timeline',
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
